import { render, staticRenderFns } from "./BaseReminder.vue?vue&type=template&id=5b93a8e4&scoped=true"
import script from "./BaseReminder.vue?vue&type=script&lang=js"
export * from "./BaseReminder.vue?vue&type=script&lang=js"
import style0 from "./BaseReminder.vue?vue&type=style&index=0&id=5b93a8e4&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b93a8e4",
  null
  
)

export default component.exports